module.exports = __webpack_public_path__ + "static/media/icon_arrow_down.486f40ce.svg";